<div class="user-settings">
  <div class="settings-nav"
    role="tablist"
    aria-orientation="vertical"
    [attr.aria-label]="'header_account-settings' | translate">
    @for (option of settingsOptions; track option) {
      @if (showLink(option)) {
        <a
          [ngClass]="{'selected': selectedOption === option}"
          (keyup.enter)="selectedOption = option"
          (click)="selectedOption = option"
          tabindex="0"
          class="menu-option"
          role="tab"
          [attr.aria-controls]="getAriaControls(option)"
          [attr.aria-selected]="selectedOption === option"
          [attr.id]="getLabel(option)"
          >
          {{ settingsOptionsTranslations[option] | translate }}
        </a>
      }
    }

  </div>
  <div class="settings-menu">
    <label translate="select-a-setting" id="select-settings-label"></label> <br />
    <mat-form-field class="go-select">
      <mat-select
        [(ngModel)]="selectedOption"
        aria-autocomplete="none"
        aria-labelledby="select-settings-label"
        disableOptionCentering
        panelClass="offsetPanel go-select-panel">
        @for (option of settingsOptions; track option) {
          @if (showLink(option)) {
            <mat-option
              [value]="option">
              {{ settingsOptionsTranslations[option] | translate }}
            </mat-option>
          }
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
    </mat-form-field>
  </div>
  <div class="settings-content" data-cy="settings-content">
    @switch (selectedOption) {
      @case (settingsOptions[0]) {
        <user-details
          [attr.role]="'tabpanel'"
          [attr.id]="settingsTabPanelIds.USER_DETAILS"
          [attr.aria-labelledby]="getLabel(settingsOptions[0])"></user-details>
      }
      @case (settingsOptions[1]) {
        <email-notifications
          [attr.role]="'tabpanel'"
          [attr.id]="settingsTabPanelIds.EMAIL_NOTIFICATIONS"
          [attr.aria-labelledby]="getLabel(settingsOptions[1])"></email-notifications>
      }
      @case (settingsOptions[2]) {
        <default-activity-settings
          [account]="account"
          [attr.role]="'tabpanel'"
          [attr.id]="settingsTabPanelIds.ACTIVITY_DEFAULTS"
          [attr.aria-labelledby]="getLabel(settingsOptions[2])"></default-activity-settings>
      }
      @case (settingsOptions[3]) {
        <billing-history
          [attr.role]="'tabpanel'"
          [attr.id]="settingsTabPanelIds.BILLING_HISTORY"
          [attr.aria-labelledby]="getLabel(settingsOptions[3])"></billing-history>
      }
    }
  </div>
</div>
